module.exports = __webpack_public_path__ + "img/step2.09c51603.png";